export const routingHelper = [
    {
        from: ["/exit-booking", "/facility-availability-check"],
        to: "/super-admin-dashboard"
    },
    {
        from: ["/add-facility", "/update-facility", "/facility-info"],
        to: "/facilities"
    },
    {
        from: ["/add-sport", "/update-sport", "/sport-info"],
        to: "/sports"
    },
    {
        from: ["/add-court", "/update-court", "/court-info"],
        to: "/courts"
    },
    {
        from: ["/add-user", "/update-user", "/user-info"],
        to: "/users"
    },
    {
        from: ["/create-session", "/update-session"],
        to: "/coaching"
    },
    {
        from: ["/service-order-details"],
        to: "/service-order"
    },
    {
        from: ["/add-court-booking", "/court-booking-summary", "/court-booking-details", "/reschedule-court-booking"],
        to: "/court-booking"
    },
    {
        from: ["/associate-booking-details", "/associate-generate-invoice", "/create-associate-booking", "/associate-booking-summary"],
        to: "/associate-booking"
    },
    {
        from: ["/coaching-session-booking-detail", "/coaching-session-booking"],
        to: "/coaching-session-booking"
    },
    {
        from: ["/add-sell-stock", "/update-sell-stock", "/sell-stock-info"],
        to: "/sell-stock"
    },
    {
        from: ["/add-rent-stock", "/update-rent-stock", "/rent-stock-info"],
        to: "/rent-stock"
    },
    {
        from: ["/add-promotional-notification", "/promotional-notification"],
        to: "/promotional-notification"
    },
    {
        from: ["/create-update-discount-offer"],
        to: "/discount-offers"
    },
    {
        from: ["/update-profile"],
        to: "/profile"
    }

];


